import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 400,
    margin: "auto"
  }
}));

export default useStyles;